import { createAction, props } from '@ngrx/store';
import { SubscriptionDiscounts } from '../types/subscription-discounts';

export const getSubscriptionDiscounts = createAction('[Subscriptions] Get Discounts');

export const getSubscriptionDiscountsSuccess = createAction(
  '[Subscriptions] Get Discounts Success',
  props<{ discounts: SubscriptionDiscounts }>(),
);

export const getSubscriptionDiscountsFailure = createAction('[Subscriptions] Get Discounts Failure');
